import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'
import globals from '@/plugins/globals.js'

export default {
  refreshRequestDevices({ commit }) {
    commit(types.SET_REQUESTDEVICES)
  },
  resetServiceRequest({ commit }) {
    commit(types.RESET_SERVICE_REQUEST)
  },
  setHubData({ commit }, data) {
    commit(types.SET_HUB_DATA, data)
  },
  setStatisticInterval({ commit }, interval) {
    commit(types.SET_INTERVAL, interval)
  },
  setConnectedDevices({ commit }, data) {
    commit(types.SET_CONNECTED_DEVICES, data)
  },
  setChatStatus({ commit }, channel) {
    commit(types.SET_CHAT_STATUS, channel)
  },
  setSelected({ commit }, data) {
    commit(types.SET_SELECTED, data)
  },
  setStatus({ commit }, data) {
    commit(types.SET_STATUS, data)
  },
  setRequest({ commit }, data) {
    commit(types.SET_REQUEST, data)
  },
  setTool({ commit }, data) {
    commit(types.SET_TOOL, data)
  },
  setToolStatus({ commit }, data) {
    commit(types.SET_TOOL_STATUS, data)
  },
  setTech({ commit }, data) {
    commit(types.SET_TECH, data)
  },
  setTechStatus({ commit }, data) {
    commit(types.SET_TECH_STATUS, data)
  },
  async getTools({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getTools', () =>
      http.get('dispatch/GetTools')
    )
    commit(types.SET_TOOLS, r.data)
    return r.data
  },
  updateMonitorInfo({ commit }, data) {
    commit(types.SET_HOST, false)
    commit(types.SET_MONITOR_INFO, data)
  },
  setHost({ commit }, value) {
    commit(types.SET_HOST, value)
  },
  async getMonitorInfo({ commit, state, dispatch }, data) {
    // TODO: use Broadcast Channel to set a last update value
    // check against that last update value to see if
    // we need to fetch data.  If not, don't do anything.
    commit(types.SET_HOST, true)
    data.appId = globals.getApp()
    const r = await startLoading(dispatch, 'getMonitorInfo', () =>
      http.get(`device/GetMonitorInfo`, {
        params: data
      })
    )
    commit(types.SET_MONITOR_INFO, r.data)
    return r.data
  },
  async getPairingInfo({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getPairingInfo', () =>
      http.get(`device/GetPairingForServiceRequest?serviceRequestId=${id}`)
    )
    commit(types.SET_PAIRING_INFO, r.data)
    return r.data
  },
  async getServiceRequest({ commit, dispatch }, id) {
    if (id !== undefined && id !== null) {
      const r = await startLoading(dispatch, 'getServiceRequest', () =>
        http.get(`servicerequest/ServiceRequestSummary?id=${id}`)
      )
      commit(types.SET_SERVICE_REQUEST, r.data)
      return r.data
    }
  },
  async getWaitTime({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getWaitTime', () =>
      http.get(`servicerequest/GetWaitTime`)
    )
    commit(types.SET_WAIT_TIME, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/astechhub/actions.js